// @flow
export const SET_UI_STATE = 'SET_UI_STATE'

export const containerIds = {
  LOGIN: 'LOGIN',
  SIGN_UP: 'SIGN_UP',
  HOST_ENTRY: 'HOST_ENTRY',
}

/**
 * Reducer section
 */
const initialState = {}

// FlowType
type Action = {
  type: string,
  containerId: string,
  payload: any,
}

export function reducer(state: Object = initialState, action: Action) {
  switch (action.type) {
    case SET_UI_STATE:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setUIState(payload: Object, containerId: string): Object {
  // if (Object.keys(containerIds).indexOf(containerId) !== -1) {
  return {
    type: SET_UI_STATE,
    // containerId,
    payload,
  }
  // }
  return {}
}
